import { getCardDefinition, getPathCardDefinition, type Direction } from "@saboteur/contracts/cards";
const EDGES: Record<Direction, string> = { N: "50 0", E: "100 70", S: "50 140", W: "0 70" };
const ENDS: Record<Direction, string> = { N: "50 40", E: "78 70", S: "50 100", W: "22 70" };

/** Each subpath corresponds to one catalog network. Singletons stop before the center. */
export function tunnelPaths(faceId: string): string[] {
  return getPathCardDefinition(faceId).networks.map((network) =>
    network.length === 1
      ? `M ${EDGES[network[0]!]} L ${ENDS[network[0]!]}`
      : network.map((edge) => `M ${EDGES[edge]} L 50 70`).join(" "),
  );
}

export function cardLabel(faceId: string): string {
  if (faceId === "start") return "Mine entrance";
  if (faceId === "goal-back") return "Hidden destination";
  if (faceId === "goal-gold") return "Gold discovered";
  if (faceId === "goal-rock") return "Rock discovered";
  if (faceId.startsWith("path-")) {
    const definition = getPathCardDefinition(faceId);
    if (definition.deadEnd)
      return `${definition.openings.length === 1 ? "Single" : definition.openings.length} blocked ${definition.openings.length === 1 ? "tunnel" : "branches"}`;
    if (definition.openings.length === 4) return "Crossroads";
    if (definition.openings.length === 3) return "Three-way tunnel";
    return (definition.openings.includes("N") && definition.openings.includes("S")) ||
      (definition.openings.includes("E") && definition.openings.includes("W"))
      ? "Straight tunnel"
      : "Corner tunnel";
  }
  return getCardDefinition(faceId).label;
}
